import PropTypes from "prop-types";
import { Box, Chip, Divider, Stack, Tooltip, Typography } from "@mui/material";
import {
  CheckCircleOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { getDatum, getDatumZeit } from "@accredo/fe-shared/services/formatService.js";
import { colorsFoundation } from "@accredo/fe-shared/theme/index.js";
import DsButton from "@accredo/fe-shared/theme/components/Button.jsx";
import { MultilineText } from "./DetailViewComponents.jsx";

export default function ReminderDetailView({ reminder, onClose }) {
  if (!reminder) return null;

  const {
    betreff,
    beschreibung,
    faellig_am,
    ist_erledigt,
    created_by,
    created_at,
  } = reminder;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, pt: 1 }}>
      <Stack direction="row" spacing={1.5} flexWrap="wrap" alignItems="center">
        <Chip
          icon={
            ist_erledigt ? (
              <CheckCircleOutlined
                sx={{
                  fontSize: "0.9rem",
                  color: `${colorsFoundation.status.positive[600]} !important`,
                }}
              />
            ) : (
              <RadioButtonUncheckedOutlined sx={{ fontSize: "0.9rem" }} />
            )
          }
          label={ist_erledigt ? "Erledigt" : "Offen"}
          size="small"
          variant="outlined"
        />
        {faellig_am && (
          <Typography variant="caption" color="text.secondary">
            Fällig am: {getDatum(faellig_am)}
          </Typography>
        )}
        {created_by && (
          <Typography variant="caption" color="text.secondary">
            Erstellt von {created_by.vorname} {created_by.nachname}
          </Typography>
        )}
        {created_at && (
          <Typography variant="caption" color="text.secondary">
            {getDatumZeit(created_at)}
          </Typography>
        )}
      </Stack>

      <Divider />

      <Tooltip title={"Betreff"}>
        <Typography variant="h3">{betreff}</Typography>
      </Tooltip>

      <Box sx={{ maxWidth: "90ch" }}>
        <MultilineText value={beschreibung} />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
        <DsButton variant="tertiary" onClick={onClose}>
          Schließen
        </DsButton>
      </Box>
    </Box>
  );
}

ReminderDetailView.propTypes = {
  reminder: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};
